import makeStyles from "@material-ui/core/styles/makeStyles";

export default makeStyles((theme) => ({
  formHelperText: {
    marginTop: theme.spacing(1),
  },
}));
